import { atom } from 'recoil'
import { sessionStorageEffect } from 'utils/store/sessionstorage.effect'
import { WarehouseArgs, WarehouseFilters } from './types'

export const containersWarehouseArguments = atom({
  key: 'containersWarehouseArguments',
  default: { name: '', id: 0 } as WarehouseArgs,
})

export const containersByWarehouseRequestId = atom({
  key: 'containersByWarehouseRequestId',
  default: 0,
})

export const containersTypeWarehouseArguments = atom({
  key: 'containersTypeWarehouseArguments',
  default: { name: '', id: 0 } as WarehouseArgs,
  effects: [sessionStorageEffect('containersTypeWarehouseArguments')],
})

export const containersTypeByWarehouseRequestId = atom({
  key: 'containersTypeByWarehouseRequestId',
  default: 0,
})

export const emptyContainersTransferArguments = atom({
  key: 'emptyContainersTransferArguments',
  default: { from: { name: '', id: 0 } as WarehouseArgs, to: { name: '', id: 0 } as WarehouseArgs },
  effects: [sessionStorageEffect('emptyContainersTransferArguments')],
})

export const emptyContainersTypeTransferRequestId = atom({
  key: 'emptyContainersTypeByWarehouseRequestId',
  default: 0,
})

export const emptyContainersIdsRequestId = atom({
  key: 'emptyContainersIdsRequestId',
  default: 0,
})

export const warehouseFilters = atom({
  key: 'warehouseFilters',
  default: { deliveryType: 0, orderNumber: 0, containerSeal: 0 } as WarehouseFilters,
})

export const cargoByOrderNumberArguments = atom<string>({
  key: 'cargoByOrderNumberArguments',
  default: '',
})

export const cargoByOrderNumberRequestId = atom<number>({
  key: 'cargoByOrderNumberRequestId',
  default: 0,
})
